var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TswagClient } from "./../commons/TswagClient";
import { Error as ApiError } from "./../models/V1/Primitives/Error/Error";
import { Psp } from "./../models/V1/Cesop/Psps/Psp";
import { MalteseAdditionalInfoDetail } from "./../models/V1/Cesop/Psps/Extensions/MalteseAdditionalInfoDetail";
import { Registration } from "./../models/V1/Cesop/Registrations/Search/Registration";
import { PspSearchResponse } from "./../models/V1/Cesop/Psps/Search/PspSearchResponse";
export class CesopPsps {
  /**
   * Creates an instance of CesopPsps.
   * @param {string} [baseUrl]
   * @param {{ fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }} [http]
   * @memberof CesopPsps
   */
  constructor(baseUrl, http) {
    __publicField(this, "http");
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
    this.http = http ? http : window;
  }
  /**
   * @param CreateRq_ _createRq
   * @returns Promise<CreateRq_>
   * @memberof CesopPsps
   */
  create(pCreateRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Psps", "POST", "application/json; charset=UTF-8", "application/json", options);
    client.addBody({ value: pCreateRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 201 }, { statusCode: 400, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param CreatePeriodsRq_ _createPeriodsRq
   * @returns Promise<CreatePeriodsRq_>
   * @memberof CesopPsps
   */
  createPeriods(pCreatePeriodsRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Psps/{pspId}/periods", "POST", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([{ name: "pspId", value: pCreatePeriodsRq.pspId, required: true }]);
    client.addBody({ value: pCreatePeriodsRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 201 }, { statusCode: 400, clazz: ApiError }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param GetRq_ _getRq
   * @returns Promise<GetRq_>
   * @memberof CesopPsps
   */
  get(pGetRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Psps/{pspId}", "GET", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([{ name: "pspId", value: pGetRq.pspId, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: Psp },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UpdateRq_ _updateRq
   * @returns Promise<UpdateRq_>
   * @memberof CesopPsps
   */
  update(pUpdateRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Psps/{pspId}", "PUT", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([{ name: "pspId", value: pUpdateRq.pspId, required: true }]);
    client.addBody({ value: pUpdateRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 400, clazz: ApiError }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param GetMalteseTokenRq_ _getMalteseTokenRq
   * @returns Promise<GetMalteseTokenRq_>
   * @memberof CesopPsps
   */
  getMalteseToken(pGetMalteseTokenRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Psps/{pspId}/extensions/mt/token", "GET", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([{ name: "pspId", value: pGetMalteseTokenRq.pspId, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 200, clazz: MalteseAdditionalInfoDetail }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UpdateMalteseTokenRq_ _updateMalteseTokenRq
   * @returns Promise<UpdateMalteseTokenRq_>
   * @memberof CesopPsps
   */
  updateMalteseToken(pUpdateMalteseTokenRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Psps/{pspId}/extensions/mt/token", "PUT", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([{ name: "pspId", value: pUpdateMalteseTokenRq.pspId, required: true }]);
    client.addBody({ value: pUpdateMalteseTokenRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 400, clazz: ApiError }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param GetPspRegistrationsRq_ _getPspRegistrationsRq
   * @returns Promise<GetPspRegistrationsRq_>
   * @memberof CesopPsps
   */
  getPspRegistrations(pGetPspRegistrationsRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Psps/{pspId}/registrations", "GET", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([{ name: "pspId", value: pGetPspRegistrationsRq.pspId, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: Registration, isArray: true },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param SearchRq_ _searchRq
   * @returns Promise<SearchRq_>
   * @memberof CesopPsps
   */
  search(pSearchRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Psps/search", "POST", "application/json; charset=UTF-8", "application/json", options);
    client.addBody({ value: pSearchRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: PspSearchResponse },
        { statusCode: 400, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
}
